module.exports = __webpack_public_path__ + "static/images/fabricius.3c80742f48b7656fd0130617334c798c.jpg";